import React from 'react';

interface ISnackbarContext {
  handleMessage: (message: string, duration?: number) => void;
}

export default React.createContext<ISnackbarContext>({
  handleMessage: (message: string) => message
});
